import { render } from "./Side.vue?vue&type=template&id=4adbe58b&scoped=true"
import script from "./Side.vue?vue&type=script&lang=js"
export * from "./Side.vue?vue&type=script&lang=js"

import "./Side.vue?vue&type=style&index=0&id=4adbe58b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4adbe58b"]])

export default __exports__